/**
 * @fileoverview
 * @enhanceable
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.UT.PROTO.MarketData.ClientDetails', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.DeltaRequest', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.DeltaResponse', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.IndexUnderlyingsRequest', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.IndexUnderlyingsResponse', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.LoginResponseStatus', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.MDLogin', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.MDLoginResponse', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.MDLoginType', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.MdlType', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.Request', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.ScripSecurityDetail', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.SecurityMappingRequest', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.SecurityMappingResponse', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.Spread', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.StrikePriceRequest', null, global);
goog.exportSymbol('proto.UT.PROTO.MarketData.StrikePriceResponse', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.ScripSecurityDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.MarketData.ScripSecurityDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.ScripSecurityDetail.displayName = 'proto.UT.PROTO.MarketData.ScripSecurityDetail';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.ScripSecurityDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.ScripSecurityDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.ScripSecurityDetail} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.ScripSecurityDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    scripName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    securityId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.ScripSecurityDetail}
 */
proto.UT.PROTO.MarketData.ScripSecurityDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.ScripSecurityDetail;
  return proto.UT.PROTO.MarketData.ScripSecurityDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.ScripSecurityDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.ScripSecurityDetail}
 */
proto.UT.PROTO.MarketData.ScripSecurityDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScripName(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSecurityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.ScripSecurityDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.ScripSecurityDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.ScripSecurityDetail} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.ScripSecurityDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScripName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSecurityId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * optional string scrip_name = 1;
 * @return {string}
 */
proto.UT.PROTO.MarketData.ScripSecurityDetail.prototype.getScripName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.UT.PROTO.MarketData.ScripSecurityDetail.prototype.setScripName = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional uint32 security_id = 2;
 * @return {number}
 */
proto.UT.PROTO.MarketData.ScripSecurityDetail.prototype.getSecurityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.ScripSecurityDetail.prototype.setSecurityId = function(value) {
  jspb.Message.setField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.Spread = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.MarketData.Spread, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.Spread.displayName = 'proto.UT.PROTO.MarketData.Spread';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.Spread.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.Spread.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.Spread} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.Spread.toObject = function(includeInstance, msg) {
  var f, obj = {
    securityId1: jspb.Message.getFieldWithDefault(msg, 1, 0),
    securityId2: jspb.Message.getFieldWithDefault(msg, 2, 0),
    securityId: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.Spread}
 */
proto.UT.PROTO.MarketData.Spread.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.Spread;
  return proto.UT.PROTO.MarketData.Spread.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.Spread} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.Spread}
 */
proto.UT.PROTO.MarketData.Spread.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSecurityId1(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSecurityId2(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSecurityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.Spread.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.Spread.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.Spread} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.Spread.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSecurityId1();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getSecurityId2();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getSecurityId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional uint32 security_id1 = 1;
 * @return {number}
 */
proto.UT.PROTO.MarketData.Spread.prototype.getSecurityId1 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.Spread.prototype.setSecurityId1 = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional uint32 security_id2 = 2;
 * @return {number}
 */
proto.UT.PROTO.MarketData.Spread.prototype.getSecurityId2 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.Spread.prototype.setSecurityId2 = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional uint32 security_id = 3;
 * @return {number}
 */
proto.UT.PROTO.MarketData.Spread.prototype.getSecurityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.Spread.prototype.setSecurityId = function(value) {
  jspb.Message.setField(this, 3, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.SecurityMappingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.UT.PROTO.MarketData.SecurityMappingRequest.repeatedFields_, null);
};
goog.inherits(proto.UT.PROTO.MarketData.SecurityMappingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.SecurityMappingRequest.displayName = 'proto.UT.PROTO.MarketData.SecurityMappingRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.UT.PROTO.MarketData.SecurityMappingRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.SecurityMappingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.SecurityMappingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.SecurityMappingRequest} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.SecurityMappingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    exchangeIdListList: jspb.Message.getField(msg, 1)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.SecurityMappingRequest}
 */
proto.UT.PROTO.MarketData.SecurityMappingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.SecurityMappingRequest;
  return proto.UT.PROTO.MarketData.SecurityMappingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.SecurityMappingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.SecurityMappingRequest}
 */
proto.UT.PROTO.MarketData.SecurityMappingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Array.<number>} */ (reader.readPackedUint32());
      msg.setExchangeIdListList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.SecurityMappingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.SecurityMappingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.SecurityMappingRequest} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.SecurityMappingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExchangeIdListList();
  if (f.length > 0) {
    writer.writePackedUint32(
      1,
      f
    );
  }
};


/**
 * repeated uint32 exchange_id_list = 1;
 * If you change this array by adding, removing or replacing elements, or if you
 * replace the array itself, then you must call the setter to update it.
 * @return {!Array.<number>}
 */
proto.UT.PROTO.MarketData.SecurityMappingRequest.prototype.getExchangeIdListList = function() {
  return /** @type {!Array.<number>} */ (jspb.Message.getField(this, 1));
};


/** @param {!Array.<number>} value */
proto.UT.PROTO.MarketData.SecurityMappingRequest.prototype.setExchangeIdListList = function(value) {
  jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!number} value
 * @param {number=} opt_index
 */
proto.UT.PROTO.MarketData.SecurityMappingRequest.prototype.addExchangeIdList = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


proto.UT.PROTO.MarketData.SecurityMappingRequest.prototype.clearExchangeIdListList = function() {
  this.setExchangeIdListList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.UT.PROTO.MarketData.SecurityMappingResponse.repeatedFields_, null);
};
goog.inherits(proto.UT.PROTO.MarketData.SecurityMappingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.SecurityMappingResponse.displayName = 'proto.UT.PROTO.MarketData.SecurityMappingResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.SecurityMappingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.SecurityMappingResponse} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    exchangeId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    scripsecuritydetailListList: jspb.Message.toObjectList(msg.getScripsecuritydetailListList(),
    proto.UT.PROTO.MarketData.ScripSecurityDetail.toObject, includeInstance),
    spreadListList: jspb.Message.toObjectList(msg.getSpreadListList(),
    proto.UT.PROTO.MarketData.Spread.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.SecurityMappingResponse}
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.SecurityMappingResponse;
  return proto.UT.PROTO.MarketData.SecurityMappingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.SecurityMappingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.SecurityMappingResponse}
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExchangeId(value);
      break;
    case 2:
      var value = new proto.UT.PROTO.MarketData.ScripSecurityDetail;
      reader.readMessage(value,proto.UT.PROTO.MarketData.ScripSecurityDetail.deserializeBinaryFromReader);
      msg.addScripsecuritydetailList(value);
      break;
    case 3:
      var value = new proto.UT.PROTO.MarketData.Spread;
      reader.readMessage(value,proto.UT.PROTO.MarketData.Spread.deserializeBinaryFromReader);
      msg.addSpreadList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.SecurityMappingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.SecurityMappingResponse} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getScripsecuritydetailListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.UT.PROTO.MarketData.ScripSecurityDetail.serializeBinaryToWriter
    );
  }
  f = message.getSpreadListList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.UT.PROTO.MarketData.Spread.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 exchange_id = 1;
 * @return {number}
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse.prototype.getExchangeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.SecurityMappingResponse.prototype.setExchangeId = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * repeated ScripSecurityDetail scripsecuritydetail_list = 2;
 * If you change this array by adding, removing or replacing elements, or if you
 * replace the array itself, then you must call the setter to update it.
 * @return {!Array.<!proto.UT.PROTO.MarketData.ScripSecurityDetail>}
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse.prototype.getScripsecuritydetailListList = function() {
  return /** @type{!Array.<!proto.UT.PROTO.MarketData.ScripSecurityDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.UT.PROTO.MarketData.ScripSecurityDetail, 2));
};


/** @param {!Array.<!proto.UT.PROTO.MarketData.ScripSecurityDetail>} value */
proto.UT.PROTO.MarketData.SecurityMappingResponse.prototype.setScripsecuritydetailListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.UT.PROTO.MarketData.ScripSecurityDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.UT.PROTO.MarketData.ScripSecurityDetail}
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse.prototype.addScripsecuritydetailList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.UT.PROTO.MarketData.ScripSecurityDetail, opt_index);
};


proto.UT.PROTO.MarketData.SecurityMappingResponse.prototype.clearScripsecuritydetailListList = function() {
  this.setScripsecuritydetailListList([]);
};


/**
 * repeated Spread spread_list = 3;
 * If you change this array by adding, removing or replacing elements, or if you
 * replace the array itself, then you must call the setter to update it.
 * @return {!Array.<!proto.UT.PROTO.MarketData.Spread>}
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse.prototype.getSpreadListList = function() {
  return /** @type{!Array.<!proto.UT.PROTO.MarketData.Spread>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.UT.PROTO.MarketData.Spread, 3));
};


/** @param {!Array.<!proto.UT.PROTO.MarketData.Spread>} value */
proto.UT.PROTO.MarketData.SecurityMappingResponse.prototype.setSpreadListList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.UT.PROTO.MarketData.Spread=} opt_value
 * @param {number=} opt_index
 * @return {!proto.UT.PROTO.MarketData.Spread}
 */
proto.UT.PROTO.MarketData.SecurityMappingResponse.prototype.addSpreadList = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.UT.PROTO.MarketData.Spread, opt_index);
};


proto.UT.PROTO.MarketData.SecurityMappingResponse.prototype.clearSpreadListList = function() {
  this.setSpreadListList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.ClientDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.MarketData.ClientDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.ClientDetails.displayName = 'proto.UT.PROTO.MarketData.ClientDetails';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.ClientDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.ClientDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.ClientDetails} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.ClientDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    mdlType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.ClientDetails}
 */
proto.UT.PROTO.MarketData.ClientDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.ClientDetails;
  return proto.UT.PROTO.MarketData.ClientDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.ClientDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.ClientDetails}
 */
proto.UT.PROTO.MarketData.ClientDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.UT.PROTO.MarketData.MdlType} */ (reader.readEnum());
      msg.setMdlType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.ClientDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.ClientDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.ClientDetails} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.ClientDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMdlType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional MdlType mdl_type = 1;
 * @return {!proto.UT.PROTO.MarketData.MdlType}
 */
proto.UT.PROTO.MarketData.ClientDetails.prototype.getMdlType = function() {
  return /** @type {!proto.UT.PROTO.MarketData.MdlType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.UT.PROTO.MarketData.MdlType} value */
proto.UT.PROTO.MarketData.ClientDetails.prototype.setMdlType = function(value) {
  jspb.Message.setField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.MarketData.IndexUnderlyingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.IndexUnderlyingsRequest.displayName = 'proto.UT.PROTO.MarketData.IndexUnderlyingsRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.IndexUnderlyingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.IndexUnderlyingsRequest} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    indexSymbolId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.IndexUnderlyingsRequest}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.IndexUnderlyingsRequest;
  return proto.UT.PROTO.MarketData.IndexUnderlyingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.IndexUnderlyingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.IndexUnderlyingsRequest}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIndexSymbolId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.IndexUnderlyingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.IndexUnderlyingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIndexSymbolId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 index_symbol_id = 1;
 * @return {number}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsRequest.prototype.getIndexSymbolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.IndexUnderlyingsRequest.prototype.setIndexSymbolId = function(value) {
  jspb.Message.setField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.repeatedFields_, null);
};
goog.inherits(proto.UT.PROTO.MarketData.IndexUnderlyingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.displayName = 'proto.UT.PROTO.MarketData.IndexUnderlyingsResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.IndexUnderlyingsResponse} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    indexSymbolId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    underlyingsListList: jspb.Message.getField(msg, 2)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.IndexUnderlyingsResponse}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.IndexUnderlyingsResponse;
  return proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.IndexUnderlyingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.IndexUnderlyingsResponse}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIndexSymbolId(value);
      break;
    case 2:
      var value = /** @type {!Array.<number>} */ (reader.readPackedInt64());
      msg.setUnderlyingsListList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.IndexUnderlyingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIndexSymbolId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUnderlyingsListList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 index_symbol_id = 1;
 * @return {number}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.prototype.getIndexSymbolId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.prototype.setIndexSymbolId = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * repeated int64 underlyings_list = 2;
 * If you change this array by adding, removing or replacing elements, or if you
 * replace the array itself, then you must call the setter to update it.
 * @return {!Array.<number>}
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.prototype.getUnderlyingsListList = function() {
  return /** @type {!Array.<number>} */ (jspb.Message.getField(this, 2));
};


/** @param {!Array.<number>} value */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.prototype.setUnderlyingsListList = function(value) {
  jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!number} value
 * @param {number=} opt_index
 */
proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.prototype.addUnderlyingsList = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


proto.UT.PROTO.MarketData.IndexUnderlyingsResponse.prototype.clearUnderlyingsListList = function() {
  this.setUnderlyingsListList([]);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.MDLogin = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.MarketData.MDLogin, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.MDLogin.displayName = 'proto.UT.PROTO.MarketData.MDLogin';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.MDLogin.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.MDLogin.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.MDLogin} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.MDLogin.toObject = function(includeInstance, msg) {
  var f, obj = {
    token: jspb.Message.getFieldWithDefault(msg, 1, ""),
    loginType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.MDLogin}
 */
proto.UT.PROTO.MarketData.MDLogin.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.MDLogin;
  return proto.UT.PROTO.MarketData.MDLogin.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.MDLogin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.MDLogin}
 */
proto.UT.PROTO.MarketData.MDLogin.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setToken(value);
      break;
    case 2:
      var value = /** @type {!proto.UT.PROTO.MarketData.MDLoginType} */ (reader.readEnum());
      msg.setLoginType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.MDLogin.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.MDLogin.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.MDLogin} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.MDLogin.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLoginType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string token = 1;
 * @return {string}
 */
proto.UT.PROTO.MarketData.MDLogin.prototype.getToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.UT.PROTO.MarketData.MDLogin.prototype.setToken = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional MDLoginType login_type = 2;
 * @return {!proto.UT.PROTO.MarketData.MDLoginType}
 */
proto.UT.PROTO.MarketData.MDLogin.prototype.getLoginType = function() {
  return /** @type {!proto.UT.PROTO.MarketData.MDLoginType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.UT.PROTO.MarketData.MDLoginType} value */
proto.UT.PROTO.MarketData.MDLogin.prototype.setLoginType = function(value) {
  jspb.Message.setField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.MDLoginResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.MarketData.MDLoginResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.MDLoginResponse.displayName = 'proto.UT.PROTO.MarketData.MDLoginResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.MDLoginResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.MDLoginResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.MDLoginResponse} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.MDLoginResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    loginStatus: jspb.Message.getFieldWithDefault(msg, 1, 0),
    responsetext: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.MDLoginResponse}
 */
proto.UT.PROTO.MarketData.MDLoginResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.MDLoginResponse;
  return proto.UT.PROTO.MarketData.MDLoginResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.MDLoginResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.MDLoginResponse}
 */
proto.UT.PROTO.MarketData.MDLoginResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.UT.PROTO.MarketData.LoginResponseStatus} */ (reader.readEnum());
      msg.setLoginStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponsetext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.MDLoginResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.MDLoginResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.MDLoginResponse} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.MDLoginResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLoginStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getResponsetext();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional LoginResponseStatus login_status = 1;
 * @return {!proto.UT.PROTO.MarketData.LoginResponseStatus}
 */
proto.UT.PROTO.MarketData.MDLoginResponse.prototype.getLoginStatus = function() {
  return /** @type {!proto.UT.PROTO.MarketData.LoginResponseStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {!proto.UT.PROTO.MarketData.LoginResponseStatus} value */
proto.UT.PROTO.MarketData.MDLoginResponse.prototype.setLoginStatus = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional string responseText = 2;
 * @return {string}
 */
proto.UT.PROTO.MarketData.MDLoginResponse.prototype.getResponsetext = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.UT.PROTO.MarketData.MDLoginResponse.prototype.setResponsetext = function(value) {
  jspb.Message.setField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.StrikePriceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.MarketData.StrikePriceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.StrikePriceRequest.displayName = 'proto.UT.PROTO.MarketData.StrikePriceRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.StrikePriceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.StrikePriceRequest} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    exchangeId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    expiryDate: jspb.Message.getFieldWithDefault(msg, 2, ""),
    strikePrice: jspb.Message.getFieldWithDefault(msg, 3, 0),
    optionMode: jspb.Message.getFieldWithDefault(msg, 4, 0),
    symbolName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    expiryType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    expiryOffset: jspb.Message.getFieldWithDefault(msg, 7, 0),
    requestId: jspb.Message.getFieldWithDefault(msg, 8, 0),
    strikeSelection: jspb.Message.getFieldWithDefault(msg, 9, 0),
    instrumentType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    timestamp: jspb.Message.getFieldWithDefault(msg, 11, 0),
    groupName: jspb.Message.getFieldWithDefault(msg, 12, ""),
    underlyingType: jspb.Message.getFieldWithDefault(msg, 13, 0),
    candleInterval: jspb.Message.getFieldWithDefault(msg, 14, 0),
    itmDepth: jspb.Message.getFieldWithDefault(msg, 15, 0),
    otmDepth: jspb.Message.getFieldWithDefault(msg, 16, 0),
    minPriceRange: jspb.Message.getFieldWithDefault(msg, 17, 0),
    maxPriceRange: jspb.Message.getFieldWithDefault(msg, 18, 0),
    strikeOperator: jspb.Message.getFieldWithDefault(msg, 19, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.StrikePriceRequest}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.StrikePriceRequest;
  return proto.UT.PROTO.MarketData.StrikePriceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.StrikePriceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.StrikePriceRequest}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExchangeId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpiryDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStrikePrice(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOptionMode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpiryType(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setExpiryOffset(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRequestId(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStrikeSelection(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInstrumentType(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupName(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUnderlyingType(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCandleInterval(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setItmDepth(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOtmDepth(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinPriceRange(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxPriceRange(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setStrikeOperator(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.StrikePriceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.StrikePriceRequest} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExchangeId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getExpiryDate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStrikePrice();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getOptionMode();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getSymbolName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getExpiryType();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getExpiryOffset();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getRequestId();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getStrikeSelection();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getInstrumentType();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getGroupName();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getUnderlyingType();
  if (f !== 0) {
    writer.writeUint32(
      13,
      f
    );
  }
  f = message.getCandleInterval();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getItmDepth();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getOtmDepth();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getMinPriceRange();
  if (f !== 0) {
    writer.writeInt32(
      17,
      f
    );
  }
  f = message.getMaxPriceRange();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getStrikeOperator();
  if (f !== 0) {
    writer.writeUint32(
      19,
      f
    );
  }
};


/**
 * optional uint32 exchange_id = 1;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getExchangeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setExchangeId = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional string expiry_date = 2;
 * @return {string}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getExpiryDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setExpiryDate = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional int64 strike_price = 3;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getStrikePrice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setStrikePrice = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional uint32 option_mode = 4;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getOptionMode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setOptionMode = function(value) {
  jspb.Message.setField(this, 4, value);
};


/**
 * optional string symbol_name = 5;
 * @return {string}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getSymbolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setSymbolName = function(value) {
  jspb.Message.setField(this, 5, value);
};


/**
 * optional int32 expiry_type = 6;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getExpiryType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setExpiryType = function(value) {
  jspb.Message.setField(this, 6, value);
};


/**
 * optional int32 expiry_offset = 7;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getExpiryOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setExpiryOffset = function(value) {
  jspb.Message.setField(this, 7, value);
};


/**
 * optional int64 request_id = 8;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setRequestId = function(value) {
  jspb.Message.setField(this, 8, value);
};


/**
 * optional int32 strike_selection = 9;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getStrikeSelection = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setStrikeSelection = function(value) {
  jspb.Message.setField(this, 9, value);
};


/**
 * optional uint32 instrument_type = 10;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getInstrumentType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setInstrumentType = function(value) {
  jspb.Message.setField(this, 10, value);
};


/**
 * optional int64 timestamp = 11;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setTimestamp = function(value) {
  jspb.Message.setField(this, 11, value);
};


/**
 * optional string group_name = 12;
 * @return {string}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getGroupName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/** @param {string} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setGroupName = function(value) {
  jspb.Message.setField(this, 12, value);
};


/**
 * optional uint32 underlying_type = 13;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getUnderlyingType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setUnderlyingType = function(value) {
  jspb.Message.setField(this, 13, value);
};


/**
 * optional uint32 candle_interval = 14;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getCandleInterval = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setCandleInterval = function(value) {
  jspb.Message.setField(this, 14, value);
};


/**
 * optional int32 itm_depth = 15;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getItmDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setItmDepth = function(value) {
  jspb.Message.setField(this, 15, value);
};


/**
 * optional int32 otm_depth = 16;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getOtmDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setOtmDepth = function(value) {
  jspb.Message.setField(this, 16, value);
};


/**
 * optional int32 min_price_range = 17;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getMinPriceRange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setMinPriceRange = function(value) {
  jspb.Message.setField(this, 17, value);
};


/**
 * optional int32 max_price_range = 18;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getMaxPriceRange = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setMaxPriceRange = function(value) {
  jspb.Message.setField(this, 18, value);
};


/**
 * optional uint32 strike_operator = 19;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.getStrikeOperator = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceRequest.prototype.setStrikeOperator = function(value) {
  jspb.Message.setField(this, 19, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.StrikePriceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.MarketData.StrikePriceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.StrikePriceResponse.displayName = 'proto.UT.PROTO.MarketData.StrikePriceResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.StrikePriceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.StrikePriceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.StrikePriceResponse} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.StrikePriceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    actualprice: jspb.Message.getFieldWithDefault(msg, 1, 0),
    responseid: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.StrikePriceResponse}
 */
proto.UT.PROTO.MarketData.StrikePriceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.StrikePriceResponse;
  return proto.UT.PROTO.MarketData.StrikePriceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.StrikePriceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.StrikePriceResponse}
 */
proto.UT.PROTO.MarketData.StrikePriceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActualprice(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setResponseid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.StrikePriceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.StrikePriceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.StrikePriceResponse} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.StrikePriceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActualprice();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getResponseid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 actualPrice = 1;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceResponse.prototype.getActualprice = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceResponse.prototype.setActualprice = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional int64 responseId = 2;
 * @return {number}
 */
proto.UT.PROTO.MarketData.StrikePriceResponse.prototype.getResponseid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.StrikePriceResponse.prototype.setResponseid = function(value) {
  jspb.Message.setField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.DeltaRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.MarketData.DeltaRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.DeltaRequest.displayName = 'proto.UT.PROTO.MarketData.DeltaRequest';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.DeltaRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.DeltaRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.DeltaRequest} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.DeltaRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    underlyingExchangeId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    underlyingSecurityId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    optionExchangeId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    optionSecurityId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    requestId: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.DeltaRequest}
 */
proto.UT.PROTO.MarketData.DeltaRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.DeltaRequest;
  return proto.UT.PROTO.MarketData.DeltaRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.DeltaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.DeltaRequest}
 */
proto.UT.PROTO.MarketData.DeltaRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUnderlyingExchangeId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUnderlyingSecurityId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOptionExchangeId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOptionSecurityId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.DeltaRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.DeltaRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.DeltaRequest} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.DeltaRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnderlyingExchangeId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getUnderlyingSecurityId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getOptionExchangeId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getOptionSecurityId();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getRequestId();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional uint32 underlying_exchange_id = 1;
 * @return {number}
 */
proto.UT.PROTO.MarketData.DeltaRequest.prototype.getUnderlyingExchangeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.DeltaRequest.prototype.setUnderlyingExchangeId = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional uint32 underlying_security_id = 2;
 * @return {number}
 */
proto.UT.PROTO.MarketData.DeltaRequest.prototype.getUnderlyingSecurityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.DeltaRequest.prototype.setUnderlyingSecurityId = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional uint32 option_exchange_id = 3;
 * @return {number}
 */
proto.UT.PROTO.MarketData.DeltaRequest.prototype.getOptionExchangeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.DeltaRequest.prototype.setOptionExchangeId = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional uint32 option_security_id = 4;
 * @return {number}
 */
proto.UT.PROTO.MarketData.DeltaRequest.prototype.getOptionSecurityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.DeltaRequest.prototype.setOptionSecurityId = function(value) {
  jspb.Message.setField(this, 4, value);
};


/**
 * optional int64 request_id = 5;
 * @return {number}
 */
proto.UT.PROTO.MarketData.DeltaRequest.prototype.getRequestId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.DeltaRequest.prototype.setRequestId = function(value) {
  jspb.Message.setField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.UT.PROTO.MarketData.DeltaResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.UT.PROTO.MarketData.DeltaResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.UT.PROTO.MarketData.DeltaResponse.displayName = 'proto.UT.PROTO.MarketData.DeltaResponse';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.DeltaResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.UT.PROTO.MarketData.DeltaResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.UT.PROTO.MarketData.DeltaResponse} msg The msg instance to transform.
 * @return {!Object}
 */
proto.UT.PROTO.MarketData.DeltaResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    delta: +jspb.Message.getFieldWithDefault(msg, 1, 0.0),
    responseId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    optionExchangeId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    optionSecurityId: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.UT.PROTO.MarketData.DeltaResponse}
 */
proto.UT.PROTO.MarketData.DeltaResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.UT.PROTO.MarketData.DeltaResponse;
  return proto.UT.PROTO.MarketData.DeltaResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.UT.PROTO.MarketData.DeltaResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.UT.PROTO.MarketData.DeltaResponse}
 */
proto.UT.PROTO.MarketData.DeltaResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDelta(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setResponseId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOptionExchangeId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOptionSecurityId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.UT.PROTO.MarketData.DeltaResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.UT.PROTO.MarketData.DeltaResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.UT.PROTO.MarketData.DeltaResponse} message
 * @param {!jspb.BinaryWriter} writer
 */
proto.UT.PROTO.MarketData.DeltaResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDelta();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getResponseId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOptionExchangeId();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getOptionSecurityId();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional double delta = 1;
 * @return {number}
 */
proto.UT.PROTO.MarketData.DeltaResponse.prototype.getDelta = function() {
  return /** @type {number} */ (+jspb.Message.getFieldWithDefault(this, 1, 0.0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.DeltaResponse.prototype.setDelta = function(value) {
  jspb.Message.setField(this, 1, value);
};


/**
 * optional int64 response_id = 2;
 * @return {number}
 */
proto.UT.PROTO.MarketData.DeltaResponse.prototype.getResponseId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.DeltaResponse.prototype.setResponseId = function(value) {
  jspb.Message.setField(this, 2, value);
};


/**
 * optional uint32 option_exchange_id = 3;
 * @return {number}
 */
proto.UT.PROTO.MarketData.DeltaResponse.prototype.getOptionExchangeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.DeltaResponse.prototype.setOptionExchangeId = function(value) {
  jspb.Message.setField(this, 3, value);
};


/**
 * optional uint32 option_security_id = 4;
 * @return {number}
 */
proto.UT.PROTO.MarketData.DeltaResponse.prototype.getOptionSecurityId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/** @param {number} value */
proto.UT.PROTO.MarketData.DeltaResponse.prototype.setOptionSecurityId = function(value) {
  jspb.Message.setField(this, 4, value);
};


/**
 * @enum {number}
 */
proto.UT.PROTO.MarketData.Request = {
  REQUEST_SUBSCRIPTION: 0,
  REQUEST_HEARTBEAT: 1,
  REQUEST_SECURITY_ID_MAPPING: 2,
  REQUEST_CLIENT_DETAILS: 3,
  REQUEST_SESSION_MESSAGES: 4,
  REQUEST_OHLC_DATA: 5,
  REQUEST_SNAPSHOT_DATA: 6,
  REQUEST_MOST_ACTIVE: 7,
  REQUEST_TOP_GAINERS_LOSERS: 8,
  REQUEST_MANUAL_DPR_UPDATE: 9,
  REQUEST_INDEX_UNDERLYINGS: 10,
  REQUEST_LOGIN: 11,
  REQUEST_STRIKE_PRICE_SELECTION: 12,
  REQUEST_DELTA: 13
};

/**
 * @enum {number}
 */
proto.UT.PROTO.MarketData.MDLoginType = {
  MDLOGINTYPE_DB_TOKEN: 0,
  MDLOGINTYPE_JWT_TOKEN: 1,
  MDLOGINTYPE_ES256_TOKEN: 2
};

/**
 * @enum {number}
 */
proto.UT.PROTO.MarketData.LoginResponseStatus = {
  LOGINRESPONSESTATUS_SUCCESS: 0,
  LOGINRESPONSESTATUS_FAILED: 1
};

/**
 * @enum {number}
 */
proto.UT.PROTO.MarketData.MdlType = {
  MDLTYPE_TCP: 0,
  MDLTYPE_UDP: 1,
  MDLTYPE_WEBSOCKET: 2
};

goog.object.extend(exports, proto.UT.PROTO.MarketData);
